import React from 'react';
export function SolutionSection() {
  return <section className="mb-16" data-id="element-57">
      <h2 className="text-2xl md:text-3xl font-bold text-teal-700 mb-6" data-id="element-58">
        But here's what no one had told me:
      </h2>
      <p className="text-lg mb-6" data-id="element-59">
        You can't "think" your way out of survival mode.
      </p>
      <p className="text-lg mb-6" data-id="element-60">
        You can't out-journal it. You can't out-meditate it. You can't out-talk
        it.
      </p>
      <p className="text-lg mb-6" data-id="element-61">
        Because survival patterns live in the body — not just the mind.
      </p>
      <p className="text-lg mb-6" data-id="element-62">
        And most importantly… you don't have to relive the past to heal it.
      </p>
      <div className="mb-8" data-id="element-63">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eyUqAraF1ZubWusZgaiFtr/istockphoto-804802520-612x612.jpg" alt="Person practicing mindful breathing outdoors" className="w-full rounded-lg" data-id="element-64" />
      </div>
      <p className="text-lg mb-6" data-id="element-65">
        For a long time, I thought healing meant going back through every wound.
      </p>
      <p className="text-lg mb-6" data-id="element-66">But I was terrified to do that.</p>
      <div className="bg-gray-100 p-6 rounded-lg my-8" data-id="element-67">
        <p className="text-lg mb-4" data-id="element-68">
          The breakthrough came when I discovered that you can gently rewire the
          nervous system in the present — without having to revisit or reprocess
          old trauma. That's what the{' '}
          <strong data-id="element-69">
            <a href="https://www.neurotoned.com/41-off-neuro" className="text-teal-600 hover:text-teal-700" data-id="element-70">
              30-Day Neurotoned Vagus Nerve Reset
            </a>
          </strong>{' '}
          is built for.
        </p>
        <p className="text-lg mb-4" data-id="element-71">
          It's a gentle, science-backed program that helps calm and reset the
          vagus nerve — which plays a key role in bringing the body out of
          fight, flight, or freeze.
        </p>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg my-8" data-id="element-72">
        <p className="text-xl md:text-2xl mb-4" data-id="element-73">
          When the vagus nerve is supported, your body begins to:
        </p>
        <ul className="space-y-2" data-id="element-74">
          <li className="flex items-start" data-id="element-75">
            <span className="text-green-500 font-bold mr-2" data-id="element-76">✅</span>
            <span className="text-lg" data-id="element-77">Release tension</span>
          </li>
          <li className="flex items-start" data-id="element-78">
            <span className="text-green-500 font-bold mr-2" data-id="element-79">✅</span>
            <span className="text-lg" data-id="element-80">Shift out of survival patterns</span>
          </li>
          <li className="flex items-start" data-id="element-81">
            <span className="text-green-500 font-bold mr-2" data-id="element-82">✅</span>
            <span className="text-lg" data-id="element-83">Reclaim calm and connection</span>
          </li>
          <li className="flex items-start" data-id="element-84">
            <span className="text-green-500 font-bold mr-2" data-id="element-85">✅</span>
            <span className="text-lg" data-id="element-86">Support natural energy and rest</span>
          </li>
        </ul>
      </div>
    </section>;
}